module.exports = __webpack_public_path__ + "static/media/DSCF121093-1-02.8b407b6e.jpg";